const FetchTypes = {
  login: 'login',
  forgotPassword: 'forgotPassword',
  updatePassword: 'updatePassword',
  getPost: 'getPost',
  getPosts: 'getPosts',
  getUser: 'getUser',
  addPost: 'addPost',
  updatePost: 'updatePost',
  addEntry: 'addEntry',
  updateEntry: 'updateEntry',
  removeEntry: 'removeEntry',
};

Object.freeze(FetchTypes);

export default FetchTypes;
